import { useEffect, useState } from 'react'
import { LAUNCH_DEADLINE } from '../data/offer'

const DEADLINE = new Date(LAUNCH_DEADLINE).getTime()

export type TimeLeft = {
  days: string
  hours: string
  minutes: string
  seconds: string
  expired: boolean
}

function format(msLeft: number): TimeLeft {
  const total = Math.max(0, Math.floor(msLeft / 1000))
  const days = Math.floor(total / 86400)
  const hours = Math.floor((total % 86400) / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const seconds = total % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return {
    days: pad(days),
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    expired: total === 0,
  }
}

/** Cuenta regresiva a una fecha fija de fin de lanzamiento (data/offer.ts). */
export function useCountdown(): TimeLeft {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() =>
    format(DEADLINE - Date.now()),
  )

  useEffect(() => {
    const id = window.setInterval(() => {
      setTimeLeft(format(DEADLINE - Date.now()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return timeLeft
}
